import React from 'react'

const Headset = () => (
  <svg width="24"height="24"viewBox="0 0 24 24"fill="currentColor"xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd"clipRule="evenodd"d="M3 10C3 5.03 7.03 1 12 1C16.97 1 21 5.03 21 10V17C21 18.66 19.66 20 18 20H15V12H19V10C19 6.13 15.87 3 12 3C8.13 3 5 6.13 5 10V12H9V20H6C4.34 20 3 18.66 3 17V10ZM7 14V18H6C5.45 18 5 17.55 5 17V14H7ZM19 14V17C19 17.55 18.55 18 18 18H17V14H19Z"fill="currentColor"/>
  </svg>
)

export default Headset